import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import { useAuth } from '../auth/AuthContext';
import { duelApi } from '../api/duelApi';

/** Duel lobby entry: create a room (get a shareable link) or join by code. */
export default function DuelHomePage() {
  const { user, loading, getToken, refresh } = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');

  // Duelling is sign-in only — bounce signed-out visitors to login.
  useEffect(() => {
    if (!loading && !user) navigate('/login', { state: { from: '/duel' }, replace: true });
  }, [loading, user, navigate]);

  async function create() {
    setCreating(true);
    setError('');
    try {
      const lobby = await duelApi.create(getToken, refresh);
      navigate(`/duel/${lobby.id}`);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Could not create a duel');
      setCreating(false);
    }
  }

  function join(e: React.FormEvent) {
    e.preventDefault();
    const c = code.trim();
    if (c) navigate(`/duel/${encodeURIComponent(c)}`);
  }

  if (!user) return <div><SiteHeader /><main className="page page--wide"><p className="muted">Loading…</p></main></div>;

  return (
    <div>
      <SiteHeader />
      <main className="page page--wide">
        <h1>Duel</h1>
        <p className="muted">Play a live 1v1 against a friend. Create a room and share the link, or enter a code to join theirs.</p>
        {error && <p className="error">{error}</p>}
        <div className="duel-home">
          <div className="duel-home-card">
            <h2>Start a duel</h2>
            <p className="muted">You'll get a link to send your opponent.</p>
            <button type="button" className="create-deck-btn" onClick={create} disabled={creating}>
              {creating ? 'Creating…' : '+ Create duel'}
            </button>
          </div>
          <div className="duel-home-card">
            <h2>Join a duel</h2>
            <form onSubmit={join} className="duel-join">
              <input type="text" placeholder="Duel code" value={code} onChange={e => setCode(e.target.value)} />
              <button type="submit" disabled={!code.trim()}>Join</button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
}
